<h4 id="claim-menu-para">Search for Claims</h4>
<lib-messaging [message]="errorMsg"
  [field]="messageFieldConfig"
  [messageStyle]="'form-message'"
  *ngIf="errorMsg.messageText"
  id="claim-widget-header-error"></lib-messaging>
<lib-radio type="radio"
  #claimMenuRadioTemplate
  id="claim-menu-claim-radio"
  [attr.data-dl]="JSON.stringify({da_track: 'true', event_id: claimRadioValue})"
  [group]="claimForm"></lib-radio>

<div class="row">
  <lib-input type="input"
    [field]="searchField"
    id="claim-menu-search-field"
    [group]="claimForm"
    [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-input>
</div>

<div class="d-flex justify-content-between">
  <button class="btn btn-secondary btn-sm"
    id="claim-menu-clear-button"
    (click)="clearData()"
    [attr.data-dl]="JSON.stringify({da_track: 'true'})">Clear</button>
  <button class="btn btn-primary btn-sm"
    id="claim-menu-submit-button"
    (click)="search()"
    type="submit"
    [attr.data-dl]="JSON.stringify({da_track: 'true'})">Search</button>
</div>